import React from 'react';

import { Snackbar } from '@crehana/ui';
import CheckO2 from '@crehana/icons/dist/Check';

import { useTranslation } from '@crehana/i18n';

import { ProductItem } from 'Jsx/CheckoutV4/types';

const DiscountSummary: React.FC<{
  checkoutProductDetail: ProductItem;
  className?: string;
}> = ({
  checkoutProductDetail: {
    codeSymbol,
    subtotal,
    price,
    credit,
    userDiscount,
    couponCode,
    couponValueDiscount,
  },
  className,
}) => {
  const { t } = useTranslation();
  const [showSnackbar, setShowSnackbar] = React.useState<boolean>(false);
  const discountAmount = subtotal! - price!;

  const _discountAmount =
    discountAmount?.toLocaleString(undefined, { minimumFractionDigits: 2 }) ||
    null;

  React.useEffect(() => {
    setShowSnackbar(!!couponCode);
  }, [couponCode]);

  const getDiscount = () => {
    if (!discountAmount) return;
    if (couponCode) {
      return (
        <p className="flex items-center mt-8 font-body4">
          <span className="text-gray-dark">{t('COUPON_APPLIED')}</span>
          <span className="flex items-center ml-auto">
            <span className="mr-4 text-gray-main">
              ({couponValueDiscount}% Dto.)
            </span>
            <span>
              {codeSymbol} {_discountAmount}
            </span>
          </span>
        </p>
      );
    }
    if (credit) {
      return (
        <p className="flex items-center mt-8 font-body4">
          <span className="text-gray-dark">
            {credit.creditTitle === 'Cashback'
              ? t('CASHBACK_TAG')
              : t('CREDIT_TAG')}
          </span>
          <span className="flex items-center ml-auto">
            <span className="mr-4 text-gray-main">({credit.total})</span>
            <span>
              {codeSymbol} {_discountAmount}
            </span>
          </span>
        </p>
      );
    }

    if (userDiscount) {
      return (
        <p className="flex items-center mt-8 font-body4">
          <span className="text-gray-dark">{t('DISCOUNT_TAG')}</span>
          <span className="flex items-center ml-auto">
            <span className="mr-4 text-gray-main">({userDiscount?.total})</span>
            <span>
              {codeSymbol} {_discountAmount}
            </span>
          </span>
        </p>
      );
    }
  };

  return (
    <div className={className}>
      {subtotal! > price! && (
        <p className="flex items-center font-body4">
          <span className="text-gray-dark">{t('SUBTOTAL_TAG')}</span>
          <span className="flex items-center ml-auto">
            {codeSymbol} {subtotal?.toLocaleString()}
          </span>
        </p>
      )}
      {getDiscount()}

      <Snackbar
        className="p-16"
        open={showSnackbar}
        position="top-right"
        dismissOnDelay={2000}
        onDismiss={() => setShowSnackbar(false)}
      >
        <p className="flex items-center">
          <span className="mr-12">
            <CheckO2
              size={16}
              ignoreColor
              className="fill-current text-green-main"
            />
          </span>
          <span className="font-body4">{t('COUPON_SNACKBAR_TITLE')}</span>
        </p>
      </Snackbar>
    </div>
  );
};

export default DiscountSummary;
